export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

export const MAXIMUM_NUMBER_OF_AUTO_BETS = 10000

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'gs_rollify_auth_token'
export const LANGUAGE = 'gs_rollify_language'
export const OPERATOR_ID = 'gs_rollify_operator_id'
export const ROLE = 'gs_rollify_operator_role'

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/',
  crashGame: '/crash-game',
  diceGame: '/dice-game'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  CRASH: 1,
  DICE: 2
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const S3_BUCKET_ENDPOINT = 'https://gs-custom-games-storage.s3.amazonaws.com'

export const S3_BUCKET_ENDPOINT_FAST_GAMES = 'https://fastgames-dev-storage.s3.amazonaws.com'

export const DEFAULT_PAGE_CALLS = 5

export const SELECTED_FIAT = 'USD'

export const SPACE_DICE_AUTO_BET = {
  MIN: 1,
  MAX: 50
}

/* ==========================================================================
  Currency Symbols
========================================================================== */
export const CURRENCY_SYMBOL = {
  USD: '$',
  EUR: '€',

  /* NON FIAT CURRENCIES */
  BTC: '₿',
  ETH: 'Ξ',
  LTC: 'Ł',
  DOGE: 'Ð',
  XRP: 'XRP',
  USDC: 'USDC',
  SOL: 'SOL',
  TRX: 'TRX',
  USDT: 'USDT',
  ADA: 'ADA',
  BNB: 'BNB',
  TON: 'TON'
}

export const CURRENCIES = {
  USD: { isFiat: true, precision: 2, symbol: '$', label: 'US Dollar', value: 'USD', fileName: 'dollar-green.svg' },
  EUR: { isFiat: true, precision: 2, symbol: '€', label: 'Euro', value: 'EUR', fileName: '001-euro.svg' },
  BTC: { isFiat: false, precision: 8, symbol: '₿', label: 'Bitcoin', value: 'BTC', fileName: '01_btc.svg' },
  DOGE: { isFiat: false, precision: 8, symbol: 'Ð', label: 'Dogecoin', value: 'DOGE', fileName: '02_doge.svg' },
  ETH: { isFiat: false, precision: 8, symbol: 'Ξ', label: 'Ethereum', value: 'ETH', fileName: '03_eth.svg' },
  LTC: { isFiat: false, precision: 8, symbol: 'Ł', label: 'Litecoin', value: 'LTC', fileName: '04_ltc.svg' },
  XRP: { isFiat: false, precision: 8, symbol: 'XRP', label: 'Ripple', value: 'XRP', fileName: '05_xrp.svg' },
  SOL: { isFiat: false, precision: 8, symbol: 'SOL', label: 'Solana', value: 'SOL', fileName: '06_sol.svg' },
  TRX: { isFiat: false, precision: 8, symbol: 'TRX', label: 'Tron', value: 'TRX', fileName: '08_trx.svg' },
  USDT: { isFiat: false, precision: 8, symbol: 'USDT', label: 'Tether', value: 'USDT', fileName: '07_usdterc.svg' },
  USDC: { isFiat: false, precision: 8, symbol: 'USDC', label: 'USDC', value: 'USDC', fileName: '09_usdc.svg' },
  GBP: { isFiat: true, precision: 2, symbol: '£', label: 'British Pound', value: 'GBP', fileName: '003-british-pound.svg' },
  CAD: { isFiat: true, precision: 2, symbol: 'C$', label: 'Canadian Dollar', value: 'CAD', fileName: '004-canadian-dollar.svg' },
  AUD: { isFiat: true, precision: 2, symbol: 'A$', label: 'Australian Dollar', value: 'AUD', fileName: '005-australian-dollar.svg' },
  JPY: { isFiat: true, precision: 2, symbol: '¥', label: 'Japanese Yen', value: 'JPY', fileName: '006-japanese-yen.svg' },
  CHF: { isFiat: true, precision: 2, symbol: 'CHF', label: 'Swiss Franc', value: 'CHF', fileName: '007-swiss-franc.svg' },
  SEK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Swedish Krona', value: 'SEK', fileName: '017-krona.svg' },
  NOK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Norwegian Krone', value: 'NOK', fileName: '008-krone.svg' },
  NZD: { isFiat: true, precision: 2, symbol: 'NZ$', label: 'New Zealand Dollar', value: 'NZD', fileName: '009-new-zealand-dollar.svg' },
  SGD: { isFiat: true, precision: 2, symbol: 'S$', label: 'Singapore Dollar', value: 'SGD', fileName: '010-singapore-dollar.svg' },
  ZAR: { isFiat: true, precision: 2, symbol: 'R', label: 'South African Rand', value: 'ZAR', fileName: '011-south-african-rand.svg' },
  HKD: { isFiat: true, precision: 2, symbol: 'HK$', label: 'Hong Kong Dollar', value: 'HKD', fileName: '018-hong-kong-dollar.svg' },
  INR: { isFiat: true, precision: 2, symbol: '₹', label: 'Indian Rupee', value: 'INR', fileName: '014-rupee-sign.svg' },
  BRL: { isFiat: true, precision: 2, symbol: 'R$', label: 'Brazilian Real', value: 'BRL', fileName: '015-brazilian-real.svg' },
  DKK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Danish Krone', value: 'DKK', fileName: '016-danish-krone.svg' },
  PHP: { isFiat: true, precision: 2, symbol: '₱', label: 'Philippine Peso', value: 'PHP', fileName: '023-philippine-peso.svg' },
  RUB: { isFiat: true, precision: 2, symbol: '₽', label: 'Russian Ruble', value: 'RUB', fileName: '013-ruble.svg' },
  THB: { isFiat: true, precision: 2, symbol: '฿', label: 'Thai Baht', value: 'THB', fileName: '020-baht.svg' },
  TRY: { isFiat: true, precision: 2, symbol: '₺', label: 'Turkish Lira', value: 'TRY', fileName: '019-lira.svg' },
  CZK: { isFiat: true, precision: 2, symbol: 'Kč', label: 'Czech Koruna', value: 'CZK', fileName: '022-czech-koruna.svg' },
  CLP: { isFiat: true, precision: 2, symbol: 'CLP$', label: 'Chilean Peso', value: 'CLP', fileName: '021-chilean.svg' },
  MXN: { isFiat: true, precision: 2, symbol: 'MX$', label: 'Mexican Peso', value: 'MXN', fileName: '012-peso.svg' },
  PLN: { isFiat: true, precision: 2, symbol: 'zł', label: 'Polish Zloty', value: 'PLN', fileName: '024-currency.svg' },
  MYR: { isFiat: true, precision: 2, symbol: 'RM', label: 'Malaysian Ringgit', value: 'MYR', fileName: '025-rm.svg' },
  RON: { isFiat: true, precision: 2, symbol: 'lei', label: 'Romanian Leu', value: 'RON', fileName: '026-leu.svg' },
  BCH: { isFiat: false, precision: 8, symbol: 'BCH', label: 'Bitcoin Cash', value: 'BCH', fileName: 'bitcoin-bch.svg' },
  ADA: { isFiat: false, precision: 8, symbol: 'ADA', label: 'Cardano', value: 'ADA', fileName: 'cardano-ada.svg' },
  BNB: { isFiat: false, precision: 8, symbol: 'BNB', label: 'Binance Coin', value: 'BNB', fileName: 'binance-BNB.svg' },
  TON: { isFiat: false, precision: 8, symbol: 'TON', label: 'Ton Coin', value: 'TON', fileName: 'ton.svg' },
  DOT: { isFiat: false, precision: 8, symbol: 'DOT', label: 'Polkadot', value: 'DOT', fileName: 'polkadot-dot.svg' },
  LINK: { isFiat: false, precision: 8, symbol: 'LINK', label: 'Chainlink', value: 'LINK', fileName: 'chainlink-link.svg' },
  XLM: { isFiat: false, precision: 8, symbol: 'XLM', label: 'Stellar', value: 'XLM', fileName: 'stellar-xlm.svg' },
  XMR: { isFiat: false, precision: 8, symbol: 'XMR', label: 'Monero', value: 'XMR', fileName: 'monero-xmr.svg' },
  DASH: { isFiat: false, precision: 8, symbol: 'DASH', label: 'Dash', value: 'DASH', fileName: 'dash-dash.svg' },
  VET: { isFiat: false, precision: 8, symbol: 'VET', label: 'VeChain', value: 'VET', fileName: 'vechain-vet.svg' },
  ETC: { isFiat: false, precision: 8, symbol: 'ETC', label: 'Ethereum Classic', value: 'ETC', fileName: 'etherum-classic-etc.svg' },
  NEO: { isFiat: false, precision: 8, symbol: 'NEO', label: 'Neo', value: 'NEO', fileName: 'neo-neo.svg' },
  ZEC: { isFiat: false, precision: 8, symbol: 'ZEC', label: 'Zcash', value: 'ZEC', fileName: 'zcash-zec.svg' },
  ATOM: { isFiat: false, precision: 8, symbol: 'ATOM', label: 'Cosmos', value: 'ATOM', fileName: 'cosmos-atom.svg' },
  ALGO: { isFiat: false, precision: 8, symbol: 'ALGO', label: 'Algorand', value: 'ALGO', fileName: 'algorand-algo.svg' },
  XTZ: { isFiat: false, precision: 8, symbol: 'XTZ', label: 'Tezos', value: 'XTZ', fileName: 'tezos-xtz.svg' },
  FTM: { isFiat: false, precision: 8, symbol: 'FTM', label: 'Fantom', value: 'FTM', fileName: 'fantom-ftm.svg' },
  EGLD: { isFiat: false, precision: 8, symbol: 'EGLD', label: 'Elrond', value: 'EGLD', fileName: 'elrond-egld.svg' }
}

export const CURRENCIES_ID = {
  1: 'USD',
  2: 'EUR',
  3: 'BTC',
  4: 'DOGE',
  5: 'ETH',
  6: 'LTC',
  7: 'XRP',
  8: 'SOL',
  9: 'USDT',
  10: 'TRX',
  11: 'USDC',
  12: 'ADA',
  13: 'BNB',
  14: 'TON'
}

export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}
